import React from "react";
import FaqSection from "./../components/FaqSection";

function FaqPage(props) {
  return (
    <FaqSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Frequently Asked Questions"
      subtitle=""
    ></FaqSection>
  );
}

export default FaqPage;
